import { PersistentSharedState } from '@trello/shared-state';

import type { InboxIds } from './Inbox.types';

export const cachedInboxIdsState = new PersistentSharedState<{
  [memberId: string]: InboxIds | undefined;
}>({}, { storageKey: 'inboxIds' });
